import LightBulb from "@material-symbols/svg-500/rounded/lightbulb.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const LightBulbIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: LightBulb });
	return <Icon />;
};

export default memo(LightBulbIcon);
